/**
 * Publishes a page-owned title onto the active workspace tab.
 * - `undefined`: no-op (keep the current customLabel)
 * - `null`: clear customLabel so history-derived labels can show
 * - non-empty string: set customLabel
 */
export function publishWorkspaceTabTitle(
  setActiveTabTitle: ((title: string | null) => void) | undefined,
  title: string | null | undefined
): void {
  if (!setActiveTabTitle || title === undefined || title === '') return
  setActiveTabTitle(title)
}
